import { ApiCertificazioneRicercaPostRequest, CertificazioneApi, CertificazioneDtoPagedListDto, Configuration } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';
import { pageSize } from 'store/utils';

export const postRicercaProcessi = createAsyncThunk<CertificazioneDtoPagedListDto | undefined, void, ThunkApiConfig>(
  'anagrafica/postRicercaProcessi', async (obj, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/post-ricerca-processi.json')).default;
      } else {
        const form = getState().ricercaClienti.form;
        const request: ApiCertificazioneRicercaPostRequest = {
          dataProcessDto: {
            dataInizio: new Date(form.dataInizio.getFullYear(), form.dataInizio.getMonth(), form.dataInizio.getDate(), 0, 0, 0),
            dataFine: new Date(form.dataFine.getFullYear(), form.dataFine.getMonth(), form.dataFine.getDate(), 23, 59, 59),
            ndg: form.ndg ? parseInt(form.ndg) : undefined,
            nominativo: form.nominativo,
            certificazioniFromLotto: (form.tipoCertificazione || 0) == 0 ? undefined : (form.tipoCertificazione == 1 ? false : true),
            modalitacertificazione: form.modalitaCertificazione || undefined,
            workflowId: form.processo || undefined,
            statocertificazione: form.statoCertificazione || undefined,
            pageSize: pageSize,
            pageNumber: form.paginaSelezionata
          }
        };
        return await new CertificazioneApi(getConfiguration(Configuration, extra, getState)).apiCertificazioneRicercaPost(request);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const resetForm = createAction<void, 'resetForm'>('resetForm');

export const setDataInizioAction = createAction<Date, 'setDataInizioAction'>('setDataInizioAction');
export const setDataFineAction = createAction<Date, 'setDataFineAction'>('setDataFineAction');
export const setModalitaCertificazioneAction = createAction<number, 'setModalitaCertificazioneAction'>('setModalitaCertificazioneAction');
export const setStatoCertificazioneAction = createAction<number, 'setStatoCertificazioneAction'>('setStatoCertificazioneAction');
export const setNdgCertificazioneAction = createAction<string, 'setNdgCertificazioneAction'>('setNdgCertificazioneAction');
export const setProcessoAction = createAction<number, 'setProcessoAction'>('setProcessoAction');
export const setTipoCerficazioneAction = createAction<number, 'setTipoCerficazioneAction'>('setTipoCerficazioneAction');
export const setPaginaSelezionataAction = createAction<number, 'setPaginaSelezionataAction'>('setPaginaSelezionataAction');

export const setNominativoCertificazioneAction = createAction<string, 'setNominativoCertificazioneAction'>('setNominativoCertificazioneAction');